import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    file_action: [],
    sort_type: "dir",
    sort_order: "asc",
    view_type: "grid",
    directory_children: [],
    stored_directory_children: [],
    getCountry: null,
    file_info: false,
    show_chat: false,
    show_note: false,
    show_notification: false,
    show_notifications: false,
    file_info_data: {
      dir_stat: {},
    },
    token: "",
    user_id: "",
    current_: "",
    current_file_id: "",
    path: "",
    current_directory: "My Drive",
    body_menu: false,
    slidein: false,
    slideout: false,
    menu: true,
    total_created_images: 0,
    total_created_documents: 0,
    total_created_folders: 0,
    phone: "",
    country: "",
    email: "",
    date_created: "",
    position: "",
    department: "",
    firstname: "",
    lastname: "",
    isAdmin: "",
    account_type: "",
    photo: "",
    company_photo: "",
    file_index: 0,
    preview_comment: [],
    total_comment: 0,
    commenter_id: "",
    comments: [],
    total_space: 0,
    total_space_used: 0,
    default_folders: [],
    isTrial: false,
    isStaff: false,
    isSuperAdmin: false,
    files_index: {},
    select_all: false,
    current_plan: "",
    user_plan: "",
    db: "",
    id: "",
    name: "",
    notification: [],
    can_create: false,
    create_right: false,
    edit_right: false,
    download_right: false,
    print_right: false,
    group_create_mode: false,
    user_files_path: "",
    notification_count: 0,
    shared_with_me_count: 0,
    personal_scroll: false,
    full_link: true,
    min_link: false,
    public_folder_id: "",
    is_security_question: "",
    company: "",
    embed_type: "chat",
    total_notification: 0,
    total_chat: 0,
    is_trial_active: false,
    is_plan_active: false,
    backendUrl: process.env.VUE_APP_CLIENT_URL,
    referral_link: "",
    hasOnboarded: false,
    hasCrm: false,
    hasInvex: false,
    invex_domain: '',
    invex_api_url: '',
    recent_files: []
  },
  getters: {
    INVEX_API_URL: (state) => {
      return state.invex_api_url
    },
    HAS_CRM: (state) => {
      return state.hasCrm
    },
    HAS_INVEX: (state) => {
      return state.hasInvex
    },
    INVEX_DOMAIN: (state) => {
      return state.invex_domain
    },
    RECENT_FILES: (state) => {
      return state.recent_files;
    },
    BACKENDURL: (state) => {
      return state.backendUrl;
    },
    HAS_ON_BOARDED: (state) => {
      return state.hasOnboarded;
    },
    PLAN_STATUS: (state) => {
      return state.is_plan_active;
    },
    TRIAL_STATUS: (state) => {
      return state.is_trial_active;
    },
    TOTAL_NOTIFICATION: (state) => {
      return state.total_notification;
    },
    TOTAL_CHAT: (state) => {
      return state.total_chat;
    },
    COMPANY: (state) => {
      return state.company;
    },
    PERSONAL_SCROLL: (state) => {
      return state.personal_scroll;
    },
    IS_SECURITY_QUESTION: (state) => {
      return state.is_security_question;
    },
    EMBED_TYPE: (state) => {
      return state.embed_type;
    },
    FULL_LINK: (state) => {
      return state.full_link;
    },
    MIN_LINK: (state) => {
      return state.min_link;
    },
    CURRENT_PLAN: (state) => {
      return state.current_plan;
    },
    USER_PLAN: (state) => {
      return state.user_plan;
    },
    PRINT_RIGHT: (state) => {
      return state.print_right;
    },
    CREATE_RIGHT: (state) => {
      return state.create_right;
    },
    EDIT_RIGHT: (state) => {
      return state.edit_right;
    },
    DOWNLOAD_RIGHT: (state) => {
      return state.download_right;
    },
    CAN_CREATE: (state) => {
      return state.can_create;
    },
    GROUP_CREATE_MODE: (state) => {
      return state.group_create_mode;
    },
    NOTIFICATION: (state) => {
      return state.notification;
    },
    NAME: (state) => {
      return state.name;
    },
    GET_DB: (state) => {
      return state.db;
    },
    REFERRAL_LINK: (state) => {
      return state.referral_link;
    },
    USER: (state) => {
      return state.id;
    },
    SELECT_ALL: (state) => {
      return state.select_all;
    },
    COMMENTS: (state) => {
      return state.comments;
    },
    ISTRIAL: (state) => {
      return state.isTrial;
    },
    ISSTAFF: (state) => {
      return state.isStaff;
    },
    ISSUPERADMIN: (state) => {
      return state.isSuperAdmin;
    },
    GET_DEFAULT_FOLDER: (state) => {
      return state.default_folders;
    },
    PUBLIC_FOLDER_ID: (state) => {
      return state.public_folder_id;
    },
    GET_TOTAL_USED_SPACE: (state) => {
      return state.total_space_used;
    },
    GET_TOTAL_SPACE: (state) => {
      return state.total_space;
    },
    GET_COMMENTER_ID: (state) => {
      return state.commenter_id;
    },
    GET_TOTAL_COMMENT: (state) => {
      return state.total_comment;
    },
    GET_FILES_INDEX: (state) => {
      return state.files_index;
    },
    GET_PREVIEW_COMMENT: (state) => {
      return state.preview_comment;
    },
    GET_CURRENT_: (state) => {
      return state.current_;
    },
    GET_FILE_INDEX: (state) => {
      return state.file_index;
    },
    PHOTO: (state) => {
      return state.photo;
    },
    COMPANY_PHOTO: (state) => {
      return state.company_photo;
    },
    ISADMIN: (state) => {
      return state.isAdmin;
    },
    ACCT_TYPE: (state) => {
      return state.account_type;
    },
    FIRSTNAME: (state) => {
      return state.firstname;
    },
    LASTNAME: (state) => {
      return state.lastname;
    },
    EMAIL: (state) => {
      return state.email;
    },
    PHONE: (state) => {
      return state.phone;
    },
    POSITION: (state) => {
      return state.position;
    },
    DEPARTMENT: (state) => {
      return state.department;
    },
    COUNTRY: (state) => {
      return state.country;
    },
    DATE_CREATED: (state) => {
      return state.date_created;
    },
    TOTAL_CREATED_IMAGES: (state) => {
      return state.total_created_images;
    },
    TOTAL_CREATED_DOCUMENTS: (state) => {
      return state.total_created_documents;
    },
    TOTAL_CREATED_FOLDERS: (state) => {
      return state.total_created_folders;
    },
    MENU: (state) => {
      return state.menu;
    },
    SLIDEOUT: (state) => {
      return state.slideout;
    },
    SLIDEIN: (state) => {
      return state.slidein;
    },
    BODY_MENU: (state) => {
      return state.body_menu;
    },
    GET_CURRENT_DIRECTORY: (state) => {
      return state.current_directory;
    },
    GET_FILESCOUNTRY: (state) => {
      return state.getCountry;
    },
    GET_USER_TOKEN: (state) => {
      return state.token;
    },
    FILE_ACTION: (state) => {
      return state.file_action.length;
    },
    GET_FILE_ACTION: (state) => {
      return state.file_action;
    },
    SORT_TYPE: (state) => {
      return state.sort_type;
    },
    SORT_ORDER: (state) => {
      return state.sort_order;
    },
    VIEW_TYPE: (state) => {
      return state.view_type;
    },
    DIRECTORY_CHILDREN: (state) => {
      return state.directory_children;
    },
    STORED_DIRECTORY_CHILDREN: (state) => {
      return state.stored_directory_children;
    },
    SHOW_FILE_INFO: (state) => {
      return state.file_info;
    },
    SHOW_CHAT: (state) => {
      return state.show_chat;
    },
    SHOW_NOTE: (state) => {
      return state.show_note;
    },
    SHOW_NOTIFICATION: (state) => {
      return state.show_notifications;
    },
    SHOW_EMBED: (state) => {
      return state.show_note;
    },
    GET_FILE_INFO_DATA: (state) => {
      return state.file_info_data;
    },
    GET_COMMENT_PREVIEW: (state) => {
      return state.comment_preview;
    },
    GET_CURRENT_FILE_ID: (state) => {
      return state.current_file_id;
    },
    GET_PATH: (state) => {
      return state.path;
    },
    GET_USER_FILES_PATH: (state) => {
      return state.user_files_path;
    },
    NOTIFICATION_COUNT: (state) => {
      return state.notification_count;
    },
    SHARED_WITH_ME_COUNT: (state) => {
      return state.shared_with_me_count;
    },
    showNewButton: (_, getters) => {
      if (getters.canCreateGroupFolder || getters.canCreateFileInGroup) {
        return true;
      }
      return (
        getters.GET_DB == "filesystem" ||
        getters.GET_DB == "public" ||
        getters.GET_DB == ""
      );
    },
    canCreateFiles(_, getters) {
      return (
        getters.GET_DB == "filesystem" ||
        getters.GET_DB == "public" ||
        getters.GET_DB == ""
      );
    },
    canCreateGroupFolder(_, getters) {
      return getters.GET_DB == "group" && getters.GROUP_CREATE_MODE == "true";
    },
    canCreateFileInGroup(_, getters) {
      return getters.GET_DB == "group" && getters.CREATE_RIGHT == true;
    },
  },
  mutations: {
    SET_INVEX_API_URL: (state, payload) => {
      state.invex_api_url = payload
    },
    SET_HAS_CRM: (state, payload) => {
      state.hasCrm = payload
    },
    SET_HAS_INVEX: (state, payload) => {
      state.hasInvex = payload
    },
    SET_INVEX_DOMAIN: (state, payload) => {
      state.invex_domain = payload
    },
    SET_RECENT_FILES: (state, payload) => {
      state.recent_files = payload;
    },
    SET_HAS_ON_BOARDED: (state, payload) => {
      state.hasOnboarded = payload;
    },
    SET_REFERRAL_LINK: (state, payload) => {
      state.referral_link = payload;
    },
    SET_PLAN_STATUS: (state, payload) => {
      state.is_plan_active = payload;
    },
    SET_TRIAL_STATUS: (state, payload) => {
      state.is_trial_active = payload;
    },
    SET_TOTAL_NOTIFICATION: (state, payload) => {
      state.total_notification = payload;
    },
    SET_TOTAL_CHAT: (state, payload) => {
      state.total_chat = payload;
    },
    SET_IS_SECURITY_QUESTION: (state, payload) => {
      state.is_security_question = payload;
    },
    SET_FULL_LINK: (state, payload) => {
      state.full_link = payload;
    },
    SET_MIN_LINK: (state, payload) => {
      state.min_link = payload;
    },
    SET_PERSONAL_SCROLL: (state, payload) => {
      state.personal_scroll = payload;
    },
    SET_CURRENT_PLAN: (state, payload) => {
      state.current_plan = payload;
    },
    SET_PRINT_RIGHT: (state, payload) => {
      state.print_right = payload;
    },
    SET_CREATE_RIGHT: (state, payload) => {
      state.create_right = payload;
    },
    SET_EDIT_RIGHT: (state, payload) => {
      state.edit_right = payload;
    },
    SET_DOWNLOAD_RIGHT: (state, payload) => {
      state.download_right = payload;
    },
    SET_CAN_CREATE: (state, payload) => {
      state.can_create = payload;
    },
    SET_GROUP_CREATE_MODE: (state, payload) => {
      state.group_create_mode = payload;
    },
    ADD_NOTIFICATION: (state, payload) => {
      state.notification = payload;
    },
    SET_USER_PLAN: (state, payload) => {
      state.user_plan = payload;
    },
    UPDATE_NOTIFICATION: (state, payload) => {
      state.notification.unshift(payload);
    },
    UPDATE_NOTIFICATION_COUNT: (state, payload) => {
      state.notification_count = payload;
    },
    SET_NAME: (state, payload) => {
      state.name = payload;
    },
    UPDATE_USER: (state, payload) => {
      state.id = payload;
    },
    SET_DB: (state, payload) => {
      if (payload) state.db = payload;
    },
    EMPTY_FILES_INDEX: (state) => {
      state.files_index = {};
    },
    REMOVE_FILES_INDEX: (state, payload) => {
      delete state.files_index[payload];
    },
    SET_SELECT_ALL: (state, payload) => {
      state.select_all = payload;
    },
    EMPTY_FILE_ACTION: (state) => {
      state.file_action = [];
    },
    SET_FILES_INDEX: (state, payload) => {
      state.files_index[payload[0]] = payload[1];
    },
    UPDATE_COMMENTS: (state, payload) => {
      state.comments = payload;
    },
    UPDATE_COMMENTS_LIST: (state, payload) => {
      state.comments.unshift(payload);
    },
    SET_ISTRIAL: (state, payload) => {
      state.isTrial = payload;
    },
    SET_ISSTAFF: (state, payload) => {
      state.isStaff = payload;
    },
    SET_ISSUPERADMIN: (state, payload) => {
      state.isSuperAdmin = payload;
    },
    UPDATE_SHARED_WITH_ME_COUNT: (state, payload) => {
      state.shared_with_me_count = payload;
    },
    UPDATE_DEFAULT_FOLDER: (state, payload) => {
      state.default_folders = payload;
    },
    UPDATE_PUBLIC_FOLDER_ID: (state, payload) => {
      state.public_folder_id = payload;
    },
    UPDATE_TOTAL_SPACE: (state, payload) => {
      state.total_space = payload;
    },
    UPDATE_TOTAL_USED_SPACE: (state, payload) => {
      state.total_space_used = payload;
    },
    UPDATE_COMMENTER_ID: (state, payload) => {
      state.commenter_id = payload;
    },
    UPDATE_TOTAL_COMMENT: (state, payload) => {
      state.total_comment = payload;
    },
    UPDATE_PREVIEW_COMMENT: (state, payload) => {
      state.preview_comment = payload;
    },
    SET_FILE_INDEX: (state, payload) => {
      state.file_index = payload;
    },
    SET_PHOTO: (state, payload) => {
      state.photo = payload;
    },
    SET_COMPANY_PHOTO: (state, payload) => {
      state.company_photo = payload;
    },
    SET_ACCT_TYPE: (state, payload) => {
      state.account_type = payload;
    },
    SET_ISADMIN: (state, payload) => {
      state.isAdmin = payload;
    },
    SET_FIRSTNAME: (state, payload) => {
      state.firstname = payload;
    },
    SET_LASTNAME: (state, payload) => {
      state.lastname = payload;
    },
    SET_EMAIL: (state, payload) => {
      state.email = payload;
    },
    SET_PHONE: (state, payload) => {
      state.phone = payload;
    },
    SET_POSITION: (state, payload) => {
      state.position = payload;
    },
    SET_DEPARTMENT: (state, payload) => {
      state.department = payload;
    },
    SET_COMPANY: (state, payload) => {
      state.company = payload;
    },
    SET_COUNTRY: (state, payload) => {
      state.country = payload;
    },
    SET_DATE_CREATED: (state, payload) => {
      state.date_created = payload;
    },
    UPDATE_TOTAL_CREATED_IMAGES: (state, payload) => {
      state.total_created_images = payload;
    },
    UPDATE_TOTAL_CREATED_DOCUMENTS: (state, payload) => {
      state.total_created_documents = payload;
    },
    UPDATE_TOTAL_CREATED_FOLDERS: (state, payload) => {
      state.total_created_folders = payload;
    },
    UPDATE_SLIDEIN: (state, payload) => {
      state.slidein = payload;
    },
    UPDATE_MENU: (state, payload) => {
      state.menu = payload;
    },
    UPDATE_SLIDEOUT: (state, payload) => {
      state.slideout = payload;
    },
    UPDATE_BODY_MENU: (state, payload) => {
      state.body_menu = payload;
    },
    SET_PATH: (state, payload) => {
      state.path = payload;
    },
    SET_USER_FILES_PATH: (state, payload) => {
      state.user_files_path = payload;
    },
    SET_CURRENT_DIRECTORY: (state, payload) => {
      state.current_directory = payload;
    },
    SET_USER_TOKEN: (state, payload) => {
      state.token = payload;
    },
    SET_STORED_DIRECTORY_CHILDREN: (state, payload) => {
      state.stored_directory_children = payload;
    },
    UPDATE_STORED_DIRECTORY_CHILDREN: (state, payload) => {
      state.stored_directory_children.push(payload);
    },
    SET_FILE_ACTION: (state, payload) => {
      if (payload !== "") {
        state.file_action.push(payload);
      } else {
        state.file_action = [];
      }
    },
    REMOVE_FILE_ACTION: (state, payload) => {
      let index = state.file_action.indexOf(payload);
      state.file_action.splice(index, 1);
    },
    SET_SORT_TYPE: (state, payload) => {
      state.sort_type = payload;
    },
    SET_SORT_ORDER: (state, payload) => {
      state.sort_order = payload;
    },
    SET_VIEW_TYPE: (state, payload) => {
      state.view_type = payload;
    },
    SET_CURRENT_FILE_ID: (state, payload) => {
      state.current_file_id = payload;
    },
    TOGGLE_CHAT: (state) => {
      state.show_chat = !state.show_chat;
    },
    TOGGLE_NOTE: (state) => {
      state.show_note = !state.show_note;
    },
    TOGGLE_EMBED: (state, view) => {
      state.show_note = !state.show_note;
      state.embed_type = view;
    },
    TOGGLE_NOTIFICATION: (state) => {
      state.show_notifications = !state.show_notifications;
    },
    TOGGLE_FILE_INFO: (state, payload) => {
      if (state.current_ === "") {
        state.file_info = true;
        state.current_ = payload;
      } else {
        if (payload === state.current_) {
          state.file_info = false;
          state.current_ = "";
        } else {
          state.file_info = true;
          state.current_ = payload;
        }
      }
    },
    HIDE_FILE_INFO: (state) => {
      state.file_info = false;
    },
    CLOSE_FILE_INFO: (state) => {
      state.current_ = "";
      state.file_info = false;
    },
    SET_FILE_INFO_DATA: (state, payload) => {
      state.file_info_data = payload;
    },
    SET_DIRECTORY_CHILDREN: (state, payload) => {
      state.directory_children = payload;
    },
    UPDATE_DIRECTORY_CHILDREN: (state, payload) => {
      state.directory_children.push(payload);
    },
    SORT_STORED_DIRECTORY_CHILDREN: (state) => {
      function compareValues(state) {
        return function (a, b) {
          if (
            !a.hasOwnProperty(state.sort_type) ||
            !b.hasOwnProperty(state.sort_type)
          ) {
            // property doesn't exist on either object
            return 0;
          }

          if (state.sort_type !== "date") {
            const varA =
              typeof a[state.sort_type] === "string"
                ? a[state.sort_type].toUpperCase()
                : a[state.sort_type];
            const varB =
              typeof b[state.sort_type] === "string"
                ? b[state.sort_type].toUpperCase()
                : b[state.sort_type];
            let comparison = 0;
            if (varA > varB) {
              comparison = 1;
            } else if (varA < varB) {
              comparison = -1;
            }
            return state.sort_order === "desc" ? comparison * -1 : comparison;
          } else {
            const varA = new Date(a["createdAt"]);
            const varB = new Date(b["createdAt"]);
            return state.sort_order === "desc" ? varA - varB : varB - varA;
          }
        };
      }

      state.directory_children.sort(compareValues(state));
    },
    SORT_DIRECTORY_CHILDREN: (state) => {
      function compareValues(state) {
        return function (a, b) {
          if (
            !a.hasOwnProperty(state.sort_type) ||
            !b.hasOwnProperty(state.sort_type)
          ) {
            // property doesn't exist on either object
            return 0;
          }

          if (state.sort_type === "dir" || state.sort_type === "size") {
            const varA =
              typeof a[state.sort_type] === "string"
                ? a[state.sort_type].toUpperCase()
                : a[state.sort_type];
            const varB =
              typeof b[state.sort_type] === "string"
                ? b[state.sort_type].toUpperCase()
                : b[state.sort_type];
            let comparison = 0;
            if (varA > varB) {
              comparison = 1;
            } else if (varA < varB) {
              comparison = -1;
            }
            return state.sort_order === "desc" ? comparison * -1 : comparison;
          }

          if (state.sort_type === "is_dir") {
            const varA = a["is_dir"];
            const varB = b["is_dir"];

            let comparison = 0;
            if (varA > varB) {
              comparison = 1;
            } else if (varA < varB) {
              comparison = -1;
            }
            return state.sort_order === "desc" ? 1 : comparison;
          }

          if (state.sort_type === "updatedAt") {
            const varA = new Date(a["updatedAt"]);
            const varB = new Date(b["updatedAt"]);
            return state.sort_order === "desc" ? varA - varB : varB - varA;
          }
        };
      }

      if (state.directory_children == undefined) return;
      state.directory_children.sort(compareValues(state));
    },
    SORT_NOTIFICATION: (state) => {
      function compareValues(state) {
        return function (a, b) {
          const varA = new Date(a["createdAt"]);
          const varB = new Date(b["createdAt"]);
          return varA - varB;
        };
      }

      state.notification.sort(compareValues(state));
    },
  },
  actions: {
    //   loadDir({state,commit,getters},{id,isPublic, cb}) {
    //   return new Promise(function(resolve, reject) {
    //     let items = state.files.filter(file=>file.parentId === id && file.isPublic === isPublic)
    //     if (items.length) {
    //       cb(false)
    //       commit('SET_ACTIVE_DIR',{id,items})
    //     } else{
    //       cb(true)
    //     }
    //   })
    //  }
  },
});
